import React from "react"
import Select from "react-select"
import { BrandOption } from "../../../types/BrandOption"

interface Props {
    brands: BrandOption[]
    value: BrandOption[]
    onChange: (brands: BrandOption[]) => void
    disabled?: boolean
}

export default function BrandMultiSelect({ brands, value, onChange, disabled }: Props) {
    return (
        <div className="mb-3" style={{ maxWidth: '500px' }}>
            <label className="text-muted mb-1">
                <small>Marques</small>
            </label>
            <Select
                multi
                options={brands}
                value={value}
                onChange={onChange}
                placeholder="Sélectionner une ou plusieurs marques..."
                noOptionsMessage={() => "Aucune marque trouvée"}
                disabled={disabled}
            />
        </div>
    )
}
